"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerUserIdleTracker = void 0;
var Sentry = __importStar(require("@sentry/browser"));
var Util_1 = require("../../Util");
var Event_1 = require("./Event");
var Event_2 = require("../UserLeftPage/Event");
var idleTimer;
var USER_IDLE_TIMEOUT_MS = 1000 * 60 * 10;
var handleIdlePageEvent = function (eventSender) { return __awaiter(void 0, void 0, void 0, function () {
    var pageInfo, event, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                pageInfo = (0, Util_1.getPageTrackingInfo)(window);
                if (!pageInfo)
                    return [2];
                event = (0, Event_1.formatUserIdleEvent)({ pageInfo: pageInfo });
                return [4, eventSender.send([event])];
            case 1:
                _a.sent();
                return [3, 3];
            case 2:
                error_1 = _a.sent();
                Sentry.captureException(error_1);
                return [2];
            case 3: return [2];
        }
    });
}); };
var handleUserLeftPageEvent = function (eventSender) { return __awaiter(void 0, void 0, void 0, function () {
    var pageInfo, event, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                pageInfo = (0, Util_1.getPageTrackingInfo)(window);
                if (!pageInfo)
                    return [2];
                event = (0, Event_2.formatUserLeftPageEvent)({ pageInfo: pageInfo });
                return [4, eventSender.send([event])];
            case 1:
                _a.sent();
                return [3, 3];
            case 2:
                error_2 = _a.sent();
                Sentry.captureException(error_2);
                return [2];
            case 3: return [2];
        }
    });
}); };
var registerIdleTimer = function (eventSender) {
    clearTimeout(idleTimer);
    idleTimer = setTimeout(function () { return handleIdlePageEvent(eventSender); }, USER_IDLE_TIMEOUT_MS);
};
var registerUserIdleTracker = function (eventSender) { return __awaiter(void 0, void 0, Promise, function () {
    return __generator(this, function (_a) {
        try {
            document.addEventListener("visibilitychange", function () {
                if (document.hidden) {
                    return handleUserLeftPageEvent(eventSender);
                }
            });
            document.addEventListener("mousemove", function () { return registerIdleTimer(eventSender); });
            document.addEventListener("mousedown", function () { return registerIdleTimer(eventSender); });
            document.addEventListener("keypress", function () { return registerIdleTimer(eventSender); });
            document.addEventListener("touchstart", function () { return registerIdleTimer(eventSender); });
            registerIdleTimer(eventSender);
        }
        catch (error) {
            Sentry.captureEvent(error);
            return [2];
        }
        return [2];
    });
}); };
exports.registerUserIdleTracker = registerUserIdleTracker;
